import { CrossOriginCommunication } from '../../../controllers/crossOriginCommunication/CrossOriginCommunicationController';
import { RoundIntegrityWatcher, RoundIntegrityWatcherPhases } from '../../../logger/RoundIntegrityWatcher';
import { gameStateActions } from '../../../store/slices/game/slice';
import type { WinnerType } from '../../../store/slices/game/types';
import { OutgoingMessage } from '../../crossOriginCommunication/types';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface WinnersMessage extends GameCommunicationMessageType {
  table: string;
  totalEur: string;
  winner: WinnerType[] | WinnerType;
  winnersCount: string;
}

export class CoreWinnersGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Winners;

  public process(message: WinnersMessage): void {
    RoundIntegrityWatcher.setPhase(RoundIntegrityWatcherPhases.WinnersPaid);

    const winnersList = (Array.isArray(message.winner) ? message.winner : [message.winner]).reduce(
      (acc: WinnerType[], winner) => {
        // Coerce string to a number
        const winNumber: number = +winner.win;

        if (winNumber > 0) {
          winner.win = winNumber;
          acc.push(winner);
        }

        return acc;
      },
      []
    );

    this.store.dispatch(gameStateActions.setWinners(winnersList));
    const total = Number.parseFloat(message.totalEur);
    const totalString = total && !Number.isNaN(total) ? total.toFixed(total > 100 ? 0 : 2) : '';
    this.store.dispatch(
      gameStateActions.setWinnersTotal({ totalEur: totalString, winnersCount: message.winnersCount })
    );

    CrossOriginCommunication.dispatch(OutgoingMessage.RoundEnd, {
      tableId: this.store.getState().config.tableConfig?.operatorGameId,
    });
  }
}
